import React, { useState } from "react";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";
import './chart.css';
import Content01 from "./vietnam_content_01";
import Content02 from "./vietnam_content_02";
import Content03 from "./vietnam_content_03";

export default function Chart() {
  const [counterOn, setCounterOn] = useState(false);
  return (
    <ScrollTrigger
      onEnter={() => setCounterOn(true)}
      onExit={() => setCounterOn(false)}
    >
      <div style={{ position: "relative" }}>
        <div className="chart-box-ban">
          <div className="conserve-chart-01-card-container">
            <div className="conserve-chart-01-card" style={{ width: "120px" }}>
              <center>
                <div className="conserve-chart-01-number number-content-01">
                  {counterOn && (
                    <CountUp start={0} end={74} duration={3} delay={0.3} />
                  )}
                  %
                </div>
                <div>
                  <Content01 />
                </div>
                <div className="conserve-chart-01-letter letter-content-01">
                  <h4>vFEM 2021</h4>
                </div>
              </center>
            </div>

            <div className="conserve-chart-01-card" style={{ width: "120px" }}>
              <center>
                <div className="conserve-chart-01-number number-content-02">
                  {counterOn && (
                    <CountUp start={0} end={80} duration={3} delay={0.3} />
                  )}
                  %
                </div>
                <div>
                  <Content02 />
                </div>
                <div className="conserve-chart-01-letter letter-content-02">
                  <h4>vFEM 2022</h4>
                </div>
              </center>
            </div>

            <div className="conserve-chart-01-card" style={{ width: "120px" }}>
              <center>
                <div className="conserve-chart-01-number number-content-03">
                  {counterOn && (
                    <CountUp start={0} end={80} duration={3} delay={0.3} />
                  )}
                  %
                </div>
                <div>
                  <Content03 />
                </div>
                <div className="conserve-chart-01-letter letter-content-03">
                  <h4>Target</h4>
                </div>
              </center>
            </div>
          </div>
        </div>
      </div>
    </ScrollTrigger>
  );
}
